import { FC } from 'react';

import clsx from 'clsx';

import { IconComponentProps } from '@/types';

import styles from './styles.module.scss';

import LoadingIcon from '@/assets/icons/loading.svg?react';

export const LoadingScreen: FC<IconComponentProps> = ({
  width = 52,
  height = 46,
  color = '#191960',
  fullScreen = false,
}) => (
  <div className={clsx(fullScreen && styles.fullScreen, styles.container)}>
    <LoadingIcon className={styles.icon} width={width} height={height} color={color} />
  </div>
);
